export const DVM_TOOL_JSON = {
   dvmFeedbackRows: [
      {
         options: [],
         selectedItems: [],
         textareaValue: '',
         dropdowns: 3,
         heading: 'Key Needs and Interests',
         subheadings: ['What is important to this person?'],
      },
      {
         options: [],
         selectedItems: [],
         textareaValue: '',
         dropdowns: 3,
         heading: 'Challenges and Concerns',
         subheadings: ['What is not going well for this person right now?'],
      },
      {
         options: [],
         selectedItems: [],
         textareaValue: '',
         dropdowns: 3,
         heading: 'Aspirations and Goals',
         subheadings: ['What are the long-term aspirations of this person?'],
      },
      {
         options: [],
         selectedItems: [],
         textareaValue: '',
         dropdowns: 3,
         heading: 'Engagement Plans',
         subheadings: ['What are the short-term actions and plan to drive engagement for this person?'],
      },
      {
         options: [],
         selectedItems: [],
         textareaValue: '',
         dropdowns: 3,
         heading: 'Recognitions and Appreciations',
         subheadings: ['How does this person prefer to receive recognition?', 'How can we best show them appreciation?'],
      },
   ],
}
